
import { Component, Prop } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component';
import {
  Document,
  DocumentStatus,
  File,
} from '@/types';

import { fileUtils } from '@/utils';

@Component
export default class ThirdPartyHistoryDocumentListItem extends BaseComponent {
  @Prop({ default: false }) loading?: boolean;

  @Prop({ default: () => ({}) }) document?: Document;

  @Prop({ default: () => ({}) }) options: any;

  get pLoading() {
    return this.loading;
  }

  get pDocument() {
    return this.document;
  }

  get isESign() {
    const action = this.$store.getters['actions/getById'](this.pDocument?.action);

    return action?.code === process.env.VUE_APP_ESIGN_ACTION_CODE;
  }

  get isESigned() {
    if (this.isESign) {
      const file = (this.document?.files as any[])[0];

      return file?.status === 'signed';
    }
    return false;
  }

  get attachments() {
    return this.pDocument?.attachments || [];
  }

  get highlighted() {
    const { documentId } = this.$route.query;

    return this.document?.id === documentId;
  }

  get sentDate() {
    const document = this.pDocument as any;

    return document?.sentAt || document?.signedAt || document?.assigneeStatusChangedAt;
  }

  handleCheckChange(selected: boolean) {
    const { id } = this.document as Document;

    this.$store.commit('thirdParty/setHistorySelected', { id, selected });

    this.$emit('checkChanged', this.document);
  }

  onStatusChange(status: DocumentStatus) {
    this.$store.commit('thirdParty/mutateHistoryObject', {
      ...this.document,
      status,
      selected: true,
    });
  }

  handleAddInfo() {
    this.$emit('showInfo', this.document);
  }

  get userFiles() {
    return (this.document?.files as any[] || []);
  }

  get userComments() {
    return (this.document?.comments as any[] || []).filter((comment: any) => comment.accountType === 'user');
  }

  getFileName = (file: File) => fileUtils.parseFileName(file);

  getFilePath = (file: File) => fileUtils.parseFilePath(file);

  handleDownloadClick = (e: Event) => {
    const element = e.currentTarget as Element;
    const path = element.getAttribute('path') as string;

    const { token } = this.$route.params;

    (element as any).href = fileUtils.buildThirdPartyDownloadUrl(token, path);
  };

  handleESignClick() {
    this.$emit('onESignClick', (this.document?.files as any[])[0]);
  }

  handleUploadClick(document: Document) {
    this.$emit('onUpload', document);
  }
}
